import React from "react";
import { STAR_RATING_STAR_CLASS_NAME } from "tsi-common-react/src/utils/starRating";

/**
 * The 50x50 ``svg-django/star{,-half-outline,-outline}.svg`` sprite paths,
 * shared by every flagship star-rating matrix (the FlagshipPage reviews
 * block and the FlagshipIndex inline reviews). ``STAR_SETS`` maps each
 * half-step rating to exactly 5 ``star`` / ``star-half-outline`` /
 * ``star-outline`` sprites; an unmatched/empty rating produces NO stars (no
 * entry in the map).
 */

export const STAR_PATH =
    "M49.2 21.1 38.3 31.7l2.6 15v.6c0 .8-.4 1.5-1.2 1.5-.4 0-.8-.2-1.2-.4l-13.5-7-13.5 7.1c-.4.2-.8.4-1.2.4-.9 0-1.3-.7-1.3-1.5 0-.2 0-.4.1-.6l2.6-15L.8 21.1c-.4-.4-.8-.9-.8-1.5 0-.9.9-1.3 1.7-1.4L16.8 16l6.8-13.7c.3-.6.8-1.2 1.5-1.2s1.2.7 1.5 1.2L33.4 16l15.1 2.2c.7.1 1.7.5 1.7 1.4-.2.6-.6 1.1-1 1.5";
export const STAR_HALF_OUTLINE_PATH =
    "m38.3 31.7 2.6 15c.2 1.3-.3 2.1-1.2 2.1-.3 0-.7-.1-1.2-.4l-13.5-7-13.5 7.1c-.5.2-.9.4-1.2.4-.9 0-1.4-.8-1.2-2.1l2.6-15L.8 21.1c-1.3-1.3-.9-2.6.9-2.8l15.1-2.2 6.8-13.7q.6-1.2 1.5-1.2c.5 0 1.1.4 1.5 1.2l6.8 13.7 15.1 2.2c1.8.3 2.2 1.5.9 2.8zm5.1-10.3-10.7-1.6-2-.3-.9-1.8L25 8.1V37l1.8.9 9.6 5.1-1.8-10.7-.4-2 1.5-1.4z";
export const STAR_OUTLINE_PATH =
    "M49.2 21.1 38.3 31.7l2.6 15v.6c0 .8-.4 1.5-1.2 1.5-.4 0-.8-.2-1.2-.4l-13.5-7-13.5 7.1c-.4.2-.8.4-1.2.4-.9 0-1.3-.7-1.3-1.5 0-.2 0-.4.1-.6l2.6-15-11-10.7c-.3-.4-.7-.9-.7-1.5 0-.9.9-1.3 1.7-1.4L16.8 16l6.8-13.7c.3-.6.8-1.2 1.5-1.2s1.2.7 1.5 1.2L33.4 16l15.1 2.2c.7.1 1.7.5 1.7 1.4-.2.6-.6 1.1-1 1.5m-5.8.3-12.7-1.9L25 8.1l-5.7 11.5-12.7 1.8 9.2 8.9L13.6 43 25 37l11.3 6-2.2-12.6z";

export const StarSVG = (props: { path: string }): React.JSX.Element => (
    <svg
        className={STAR_RATING_STAR_CLASS_NAME}
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width="50"
        height="50"
        viewBox="0 0 50 50"
    >
        <path d={props.path} />
    </svg>
);

export const STAR_SETS: Record<string, readonly string[]> = {
    "1": [
        STAR_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
    ],
    "1.5": [
        STAR_PATH,
        STAR_HALF_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
    ],
    "2": [
        STAR_PATH,
        STAR_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
    ],
    "2.5": [
        STAR_PATH,
        STAR_PATH,
        STAR_HALF_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
    ],
    "3": [
        STAR_PATH,
        STAR_PATH,
        STAR_PATH,
        STAR_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
    ],
    "3.5": [
        STAR_PATH,
        STAR_PATH,
        STAR_PATH,
        STAR_HALF_OUTLINE_PATH,
        STAR_OUTLINE_PATH,
    ],
    "4": [STAR_PATH, STAR_PATH, STAR_PATH, STAR_PATH, STAR_OUTLINE_PATH],
    "4.5": [STAR_PATH, STAR_PATH, STAR_PATH, STAR_PATH, STAR_HALF_OUTLINE_PATH],
    "5": [STAR_PATH, STAR_PATH, STAR_PATH, STAR_PATH, STAR_PATH],
};
